/**
 * @typedef {Object} PurifyOptions
 * @property {string[]} [ALLOWED_TAGS] - Array of allowed HTML tags
 * @property {string[]} [ALLOWED_ATTR] - Array of allowed HTML attributes
 */

/**
 * Sanitizes text that may contain HTML/markup to protect against XSS attacks.
 * See `<SafeHtml />` for a component that wraps this functionality.
 *
 * NOTE: The result is a promise as we lazy load `dompurify` to save on initial bundle size.
 * We should evaluate - especially after CS-4298 - if lazy loading still makes sense.
 * If sanitizing becomes necessary on **all** question types then it may not be worth the complexity.
 *
 * @param {string} toPurify
 * @param {PurifyOptions} [purifyOptions={}]
 * @param {boolean} [force=true]
 * @returns {Promise<string | null>}
 */
const toDOMPurifyLazy = (toPurify, purifyOptions, force = false) => {
  return import(/* webpackChunkName: "csw-vendor-dompurify" */ "dompurify")
    .then((module) => {
      try {
        const DOMPurify = module.default;
        return DOMPurify.sanitize(toPurify, purifyOptions);
      } catch (e) {
        //FIXME: do we want to log on the api when something there is an xss clobbering error?
        //eslint-disable-next-line
        console.log("toDOMPurifyLazy() failed", e, toPurify);
        return force ? toPurify : null;
      }
    })
    .catch((e) => {
      //eslint-disable-next-line
      console.log("dompurify failed to lazy load", e, toPurify);
      return force ? toPurify : null;
    });
};

export default toDOMPurifyLazy;
